import { useRecoilState, atom } from "recoil";

import appConfig from "../../config/app.config";
import { API_STATUS } from "../../constants/app.constants";

import useRestApiCall from "../../http.interceptor";

const { LOADING, SUCCESS, ERROR } = API_STATUS;

const USER_ACCOUNT_INFO_INITIAL_STATE = {
  status: LOADING,
  content: null,
};

const userAccountInfoAtom = atom({
  key: "userAccountInfoAtom",
  default: USER_ACCOUNT_INFO_INITIAL_STATE,
});

const userAccountInfoPayload = (userId) => {
  let apiPayload = {
    method: "GET",
    url: `/api/auth/fetch/user/account/info`,
    baseURL: appConfig.apiMarketplaceBaseUrl,
    params : {userId}
  };
  return apiPayload;
};

const useFetchUserAccountInfo = () => {
  const { apiCall } = useRestApiCall();
  const [userInfoAccount, setUserInfoAccount] = useRecoilState(userAccountInfoAtom);
  const { status,content} = userInfoAccount;
  
  const fetchUserAccountInfo = async () => {
    
    try {
      const payload = userAccountInfoPayload();
      const response = await apiCall(payload);
      if (response?.status) {
        setUserInfoAccount({ status: SUCCESS, content: response.data })
        return response;
      }
      throw new Error(response);
    } catch (error) {
      setUserInfoAccount({ status: ERROR, content: error });
    }

      
  };

  const clearUserAccountInfo = () => {
    setUserInfoAccount(USER_ACCOUNT_INFO_INITIAL_STATE);
  };

  return { status, content, fetchUserAccountInfo, clearUserAccountInfo };
};

export default useFetchUserAccountInfo;